import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { HomeIcon, UsersIcon, AlertCircleIcon, ClipboardListIcon, BarChartIcon, SettingsIcon, XIcon, ActivityIcon, UserXIcon, FileWarningIcon, AlertTriangleIcon } from 'lucide-react';
interface AdminSidebarProps {
  mobile?: boolean;
  onClose?: () => void;
}
export function AdminSidebar({
  mobile,
  onClose
}: AdminSidebarProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const navigation = [{
    name: 'Dashboard',
    icon: HomeIcon,
    path: '/admin',
    current: pathname === '/admin'
  }, {
    name: 'Clienti',
    icon: UsersIcon,
    path: '/admin/clienti',
    current: pathname === '/admin/clienti'
  }, {
    name: 'Da gestire',
    icon: AlertCircleIcon,
    items: [{
      name: 'Utenti non attivi',
      icon: UserXIcon,
      path: '/admin/utenti-non-attivi',
      current: pathname === '/admin/utenti-non-attivi'
    }, {
      name: 'Pratiche incagliate',
      icon: FileWarningIcon,
      path: '/admin/pratiche-incagliate',
      current: pathname === '/admin/pratiche-incagliate'
    }, {
      name: 'Configurazioni in sospeso',
      icon: ClipboardListIcon,
      path: '/admin/configurazioni-sospese',
      current: pathname === '/admin/configurazioni-sospese'
    }, {
      name: 'Errori vari',
      icon: AlertTriangleIcon,
      path: '/admin/errori',
      current: pathname === '/admin/errori'
    }]
  }, {
    name: 'Log',
    icon: ActivityIcon,
    path: '/admin/log',
    current: pathname === '/admin/log'
  }, {
    name: 'Report',
    icon: BarChartIcon,
    path: '/admin/report',
    current: pathname === '/admin/report'
  }, {
    name: 'Impostazioni',
    icon: SettingsIcon,
    path: '/admin/impostazioni',
    current: pathname === '/admin/impostazioni'
  }];
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(navigation.find(item => item.items?.some(subitem => subitem.current))?.name || null);
  const toggleSubmenu = (name: string) => {
    setOpenSubmenu(openSubmenu === name ? null : name);
  };
  return <div className="flex flex-col h-full bg-[#1A3E5C] w-64" data-id="element-108">
      {mobile && <div className="flex items-center justify-between px-4 py-3" data-id="element-109">
          <div className="flex items-center" data-id="element-110">
            <span className="text-white text-xl font-semibold" data-id="element-111">
              CashFirst Admin
            </span>
          </div>
          <button type="button" className="text-white" onClick={onClose} data-id="element-112">
            <XIcon className="h-6 w-6" data-id="element-113" />
          </button>
        </div>}
      {!mobile && <div className="flex items-center h-16 flex-shrink-0 px-4" data-id="element-114">
          <span className="text-white text-xl font-semibold" data-id="element-115">
            CashFirst Admin
          </span>
        </div>}
      <div className="mt-5 flex-1 flex flex-col overflow-y-auto" data-id="element-116">
        <nav className="flex-1 px-2 pb-4 space-y-1" data-id="element-117">
          {navigation.map(item => item.items ? <div key={item.name} data-id="element-118">
                <button className={`
                    w-full group flex items-center px-2 py-2 text-sm font-medium rounded-md
                    text-gray-100 hover:bg-[#15324a] hover:text-white
                  `} onClick={() => toggleSubmenu(item.name)} data-id="element-119">
                  <item.icon className={`
                      mr-3 flex-shrink-0 h-6 w-6 text-gray-300 group-hover:text-white
                    `} aria-hidden="true" data-id="element-120" />
                  <span className="flex-1 text-left" data-id="element-121">{item.name}</span>
                  <svg className={`ml-3 h-4 w-4 transition-transform ${openSubmenu === item.name ? 'transform rotate-90' : ''}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-122">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-123" />
                  </svg>
                </button>
                {openSubmenu === item.name && <div className="mt-1 space-y-1 pl-10" data-id="element-124">
                    {item.items.map(subItem => <Link key={subItem.name} to={subItem.path} className={`
                          group flex items-center px-2 py-2 text-sm font-medium rounded-md
                          ${subItem.current ? 'bg-[#15324a] text-white' : 'text-gray-100 hover:bg-[#15324a] hover:text-white'}
                        `} onClick={mobile ? onClose : undefined} data-id="element-125">
                        <subItem.icon className={`
                            mr-3 flex-shrink-0 h-5 w-5
                            ${subItem.current ? 'text-white' : 'text-gray-300 group-hover:text-white'}
                          `} aria-hidden="true" data-id="element-126" />
                        {subItem.name}
                      </Link>)}
                  </div>}
              </div> : <Link key={item.name} to={item.path} className={`
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md
                  ${item.current ? 'bg-[#15324a] text-white' : 'text-gray-100 hover:bg-[#15324a] hover:text-white'}
                `} onClick={mobile ? onClose : undefined} data-id="element-127">
                <item.icon className={`
                    mr-3 flex-shrink-0 h-6 w-6
                    ${item.current ? 'text-white' : 'text-gray-300 group-hover:text-white'}
                  `} aria-hidden="true" data-id="element-128" />
                {item.name}
              </Link>)}
        </nav>
      </div>
    </div>;
}